import { sortBy } from "underscore";
import { defineApiQuery } from "utils/queries";
import { api, OnError, OnSuccess } from "./restUtil";

export type Level = {
  id: string;
  name: string;
  score_range: [number, number];
  value: number;
};

type LevelListResponse = {
  list: Level[];
};

export function fetchLevels(
  _args: void,
  onSuccess: OnSuccess<Level[]>,
  onError: OnError
) {
  fetchLevelsAsync().then(onSuccess, onError);
}

export async function fetchLevelsAsync() {
  const resp = await api.get<LevelListResponse>("/levels");
  return sortBy(resp.list, "value");
}

export const getLevels = defineApiQuery({
  key: "/levels",
  queryFn: fetchLevelsAsync,
});
